(function(){
'use strict';

/*
  BGC cart scroll preservation — isolated, one-shot repair.
  Retina remains authoritative for native quantity/remove behavior and drawer rendering.
  This script only remembers the user's internal drawer position before a native cart-line
  interaction and restores that position once after Retina redraws the cart rows.
*/
if(window.__BGC_CART_SCROLL_PRESERVE_2026__)return;
window.__BGC_CART_SCROLL_PRESERVE_2026__=1;

var CONTROL_SELECTOR='#cart .plus, #cart .minus, #cart .trash-alt, #cart [class*="trash"], #cart [data-remove], #cart a[href*="change"], #cart a[href*="remove"]';
var pending=null;

function q(selector,root){return (root||document).querySelector(selector);}
function qa(selector,root){return Array.prototype.slice.call((root||document).querySelectorAll(selector));}
function cartRoot(){return document.getElementById('cart');}
function rows(root){
  return root?qa('li',root).filter(function(row){return !!q('.updates[data-id]',row)&&!!q('a.cart__item',row);}):[];
}
function variantOf(row){
  var input=row&&q('.updates[data-id]',row);
  return input?String(input.getAttribute('data-id')||''):'';
}
function lineOf(row){
  var input=row&&q('.updates[data-line-id]',row);
  return input?String(input.getAttribute('data-line-id')||''):'';
}
function keyOf(row){
  return row&&row.dataset&&row.dataset.bgcCartKey?String(row.dataset.bgcCartKey):'';
}
function occurrenceOf(row,variant,allRows){
  var same=(allRows||[]).filter(function(candidate){return variantOf(candidate)===variant;});
  return same.indexOf(row);
}
function isScrollable(element){
  if(!element||element===document.body||element===document.documentElement)return false;
  if(element.scrollHeight<=element.clientHeight+2)return false;
  var style=window.getComputedStyle?window.getComputedStyle(element):null;
  if(!style)return false;
  var overflowY=String(style.overflowY||'');
  var overflow=String(style.overflow||'');
  return /(auto|scroll|overlay)/.test(overflowY)||/(auto|scroll|overlay)/.test(overflow);
}
function findScroller(row,root){
  if(!row||!root)return null;
  var node=row.parentElement;
  while(node){
    if(node===document.body||node===document.documentElement)return null;
    if(node!==root&&!root.contains(node))return null;
    if(isScrollable(node))return node;
    if(node===root)break;
    node=node.parentElement;
  }
  return isScrollable(root)?root:null;
}
function maxScroll(element){return Math.max(0,element.scrollHeight-element.clientHeight);}
function clamp(value,min,max){return Math.max(min,Math.min(max,value));}
function quantityOf(row){
  var input=row&&q('.updates',row);
  var value=input?parseInt(input.value,10):NaN;
  return isFinite(value)?value:null;
}
function removesLine(control,row){
  if(!control)return false;
  if(control.classList&&control.classList.contains('minus')){
    var quantity=quantityOf(row);
    return quantity!==null&&quantity<=1;
  }
  return !!(control.classList&&control.classList.contains('trash-alt'))||
    (control.matches&&control.matches('[data-remove], [class*="trash"], a[href*="remove"]'));
}
function nativeRowsTouched(mutations){
  return mutations.some(function(mutation){
    var nodes=[];
    if(mutation.addedNodes)nodes=nodes.concat(Array.prototype.slice.call(mutation.addedNodes));
    if(mutation.removedNodes)nodes=nodes.concat(Array.prototype.slice.call(mutation.removedNodes));
    return nodes.some(function(node){
      if(!node||node.nodeType!==1)return false;
      if(node.classList&&node.classList.contains('bgc-drawer-purchase'))return false;
      if(node.matches&&(node.matches('li')||node.matches('.updates[data-id]')||node.matches('a.cart__item')))return true;
      return !!(node.querySelector&&node.querySelector('li .updates[data-id], li a.cart__item'));
    });
  });
}
function findSameRow(snapshot,root){
  var allRows=rows(root);
  var i,row;

  if(snapshot.key){
    for(i=0;i<allRows.length;i++){
      row=allRows[i];
      if(keyOf(row)===snapshot.key)return row;
    }
  }

  if(snapshot.line){
    for(i=0;i<allRows.length;i++){
      row=allRows[i];
      if(lineOf(row)===snapshot.line&&(!snapshot.variant||variantOf(row)===snapshot.variant))return row;
    }
  }

  if(snapshot.variant&&snapshot.occurrence>=0){
    var same=allRows.filter(function(candidate){return variantOf(candidate)===snapshot.variant;});
    if(same[snapshot.occurrence])return same[snapshot.occurrence];
  }
  return null;
}
function finish(snapshot){
  if(!snapshot||snapshot.finished)return;
  snapshot.finished=true;
  if(snapshot.observer)try{snapshot.observer.disconnect();}catch(e){}
  if(snapshot.fallbackTimer)clearTimeout(snapshot.fallbackTimer);
  if(pending===snapshot)pending=null;

  var root=cartRoot();
  if(!root)return;

  var target=snapshot.removing?null:findSameRow(snapshot,root);
  var scroller=null;
  if(target)scroller=findScroller(target,root);
  if(!scroller&&snapshot.scroller&&document.documentElement.contains(snapshot.scroller)&&root.contains(snapshot.scroller))scroller=snapshot.scroller;
  if(!scroller)return;

  scroller.scrollTop=clamp(snapshot.scrollTop,0,maxScroll(scroller));

  if(!target)return;

  window.requestAnimationFrame(function(){
    if(!document.documentElement.contains(scroller)||!document.documentElement.contains(target))return;
    var scrollerRect=scroller.getBoundingClientRect();
    var targetRect=target.getBoundingClientRect();
    var newOffset=targetRect.top-scrollerRect.top;
    var adjustment=newOffset-snapshot.rowOffset;
    if(Math.abs(adjustment)>0.5){
      scroller.scrollTop=clamp(scroller.scrollTop+adjustment,0,maxScroll(scroller));
    }
  });
}
function scheduleRestore(snapshot){
  if(!snapshot||snapshot.restoreScheduled||snapshot.finished)return;
  snapshot.restoreScheduled=true;
  window.requestAnimationFrame(function(){
    window.requestAnimationFrame(function(){finish(snapshot);});
  });
}
function capture(event){
  if(event.isTrusted===false||!event.target||!event.target.closest)return;
  var control=event.target.closest(CONTROL_SELECTOR);
  if(!control)return;

  var root=cartRoot();
  if(!root||!root.contains(control))return;
  var row=control.closest('li');
  if(!row||!root.contains(row)||!q('.updates[data-id]',row))return;

  var scroller=findScroller(row,root);
  if(!scroller)return;

  if(pending&&!pending.finished)finish(pending);

  var allRows=rows(root);
  var variant=variantOf(row);
  var scrollerRect=scroller.getBoundingClientRect();
  var rowRect=row.getBoundingClientRect();
  var snapshot={
    key:keyOf(row),
    line:lineOf(row),
    variant:variant,
    occurrence:occurrenceOf(row,variant,allRows),
    removing:removesLine(control,row),
    scrollTop:scroller.scrollTop,
    rowOffset:rowRect.top-scrollerRect.top,
    scroller:scroller,
    observer:null,
    fallbackTimer:0,
    restoreScheduled:false,
    finished:false
  };
  pending=snapshot;

  if(typeof MutationObserver!=='undefined'){
    snapshot.observer=new MutationObserver(function(mutations){
      if(nativeRowsTouched(mutations)){
        try{snapshot.observer.disconnect();}catch(e){}
        scheduleRestore(snapshot);
      }
    });
    snapshot.observer.observe(root,{childList:true,subtree:true});
  }

  snapshot.fallbackTimer=setTimeout(function(){scheduleRestore(snapshot);},2500);
}

document.addEventListener('click',capture,true);
})();
